import { render, staticRenderFns } from "./TopVideosTable.vue?vue&type=template&id=27f554ca&scoped=true&"
import script from "./TopVideosTable.vue?vue&type=script&lang=js&"
export * from "./TopVideosTable.vue?vue&type=script&lang=js&"
import style0 from "./TopVideosTable.vue?vue&type=style&index=0&id=27f554ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f554ca",
  null
  
)

export default component.exports